import "a11y-accordion-tabs"

var tabs = document.getElementById("myTabs");

new AccordionTabs(tabs);
